import { TFieldSchema } from '../schemas/payment-provider-schema';

/**
 * Acquirer-verified starter schemas.
 *
 * Field ids must match the kiosk app's storage keys EXACTLY — they are
 * case-sensitive, and `id`/`type`/`scope` are immutable once created. A typo
 * produces no error anywhere; it just silently breaks card payment. These
 * presets exist so ops never has to retype them.
 *
 * Everything stays editable after the template is applied.
 */
export type TStarterSchema = {
  providerId: string;
  displayName: string;
  fields: TFieldSchema[];
};

export const STARTER_SCHEMAS: TStarterSchema[] = [
  {
    providerId: 'dojo',
    displayName: 'Dojo',
    fields: [
      { id: 'reseller_id', type: 'text', scope: 'global', required: true, displayOrder: 1 },
      { id: 'software_house_id', type: 'text', scope: 'global', required: true, displayOrder: 2 },
      { id: 'api_key', type: 'secret', scope: 'client', required: true, displayOrder: 1 },
      { id: 'location_reference', type: 'text', scope: 'client', required: false, displayOrder: 2 },
      { id: 'terminal_id', type: 'text', scope: 'device', required: true, displayOrder: 1 },
    ],
  },
  {
    providerId: 'sumup_solo',
    displayName: 'SumUp Solo',
    fields: [
      { id: 'affiliate_app_id', type: 'text', scope: 'global', required: false, displayOrder: 1 },
      { id: 'affiliate_key', type: 'secret', scope: 'global', required: false, displayOrder: 2 },
      { id: 'merchant_code', type: 'text', scope: 'client', required: true, displayOrder: 1 },
      { id: 'api_key', type: 'secret', scope: 'client', required: true, displayOrder: 2 },
      { id: 'reader_id', type: 'text', scope: 'device', required: true, displayOrder: 1 },
    ],
  },
  {
    providerId: 'stripe_terminal',
    displayName: 'Stripe Terminal',
    fields: [
      { id: 'publishable_key', type: 'text', scope: 'global', required: true, displayOrder: 1 },
      { id: 'secret_key', type: 'secret', scope: 'global', required: true, displayOrder: 2 },
      { id: 'stripe_account_id', type: 'text', scope: 'client', required: true, displayOrder: 1 },
      { id: 'location_id', type: 'text', scope: 'client', required: true, displayOrder: 2 },
      { id: 'reader_serial', type: 'text', scope: 'device', required: false, displayOrder: 1 },
    ],
  },
  {
    providerId: 'square',
    displayName: 'Square',
    fields: [
      { id: 'application_id', type: 'text', scope: 'global', required: true, displayOrder: 1 },
      { id: 'access_token', type: 'secret', scope: 'client', required: true, displayOrder: 1 },
      { id: 'location_id', type: 'text', scope: 'client', required: true, displayOrder: 2 },
      { id: 'device_id', type: 'text', scope: 'device', required: true, displayOrder: 1 },
    ],
  },
  {
    providerId: 'zettle',
    displayName: 'Zettle',
    fields: [
      { id: 'client_id', type: 'text', scope: 'global', required: true, displayOrder: 1 },
      { id: 'api_key', type: 'secret', scope: 'client', required: true, displayOrder: 1 },
    ],
  },
  {
    providerId: 'adyen',
    displayName: 'Adyen',
    fields: [
      { id: 'api_key', type: 'secret', scope: 'global', required: true, displayOrder: 1 },
      { id: 'merchant_account', type: 'text', scope: 'client', required: true, displayOrder: 1 },
      { id: 'poiid', type: 'text', scope: 'device', required: true, displayOrder: 1 },
    ],
  },
];
